import { TreeMixin, itemTypeLoadMore, itemTypeDefault } from './mixin';
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinTreeDefault',
  mixins: [TreeMixin],
  props: {
    searchEnabled: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data() {
    return {
      loadedInitialDtwins: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])
  },
  watch: {
    twinTreeItems() {
      if (!this.loadedInitialDtwins) {
        if (this.twinTreeItems.length > 0) {
          this.loadedInitialDtwins = true;
          this.$emit('initialDtwins', this.twinTreeItems);
        }
      }
    }
  },
  created() {
    this.itemTypeLoadMore = itemTypeLoadMore;
  },
  mounted() {
    this.initTree();
  },
  methods: {
    initTree() {
      this.twinTreeItems = [];
      this.twinItemMapping = {};
      this.active = null;
      this.twinItemMapping[this.parentId] = {};

      // an active node is specified, so make sure to load the tree-structure to accomodate this node
      // might not be on root-level, so there is special handling required to have it displayed right away
      if (this.activeDtwinId) {
        this.fetchPartialTree(this.activeDtwinId);
      } else {
        this.fetchChildren({
          id: this.parentId
        }, true);
      }
    },
    fetchChildren(item, initially = false) {
      return this.fetchChildrenDefault(item.id, 0, initially);
    },
    processTreeItems(items) {
      this.processTreeItemsDefault(items);
    },
    itemType(item) {
      if (typeof item.id === 'string') {
        if (item.id.startsWith(itemTypeLoadMore)) {
          return itemTypeLoadMore;
        }
      }
      return itemTypeDefault;
    },
    getTwinTreeIcon(dtwin) {
      // special case for the "Load More" tree item
      if (this.itemType(dtwin) === itemTypeLoadMore) {
        return this.getTwinTreeIconDefault(dtwin);
      }
      return this.getTwinTreeIconDefault(dtwin);
    }
  }
};